import Actions from '../actions/actions';
import { glockAppCRUDActions as GlockAppCRUDActions } from '../actions/GlockAppCRUDActions';
import { GlockApp } from '../interfaces/glockApp';
import { setBusy, setUnBusy } from './common/commonReducers';

interface ActionType {
  type: string;
  payload?: any;
}

const initialState: GlockApp = {
  deliverabilityScore: {},
};

export const glockApp = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case GlockAppCRUDActions.busyAction:
      return setBusy(state);
    case GlockAppCRUDActions.retrievedEmailAccountDeliverabilityScoreAction: {
      const { payload } = action;
      return {
        ...state,
        deliverabilityScore: payload,
        busy: false,
      };
    }
    case GlockAppCRUDActions.unbusyAction:
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
